var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuCh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "47px",
    height: "43px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "40px",
    height: "36px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAQAAABRNbCdAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhUUFQAHXio6AAAAeElEQVRIx+3UQQqAIBBA0W90ELv/ofQmtTLQFMaaRHBml8SLkU+OAADngcpsgMfrYAlUnQXBXfqiC/lzqwoxCFkLcdjKBk4IPrKR9iYGEfY2bGUDJwR7fl/VKbv9DFJ0O/8dGrgCeIddFv/2PIG+8cHe839WjprgBUERDlmSt2y4AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuCh);
export default __webpack_public_path__ + "static/media/mu-ch.64838aa252c882de5243dc22cde647d4.svg";
export { ForwardRef as ReactComponent };